(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Utente', Utente);

    Utente.$inject = ['$resource', 'DateUtils'];

    function Utente ($resource, DateUtils) {
        var resourceUrl =  'api/utentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataInizioDirezione = DateUtils.convertLocalDateFromServer(data.dataInizioDirezione);
                        data.dataFineDirezione = DateUtils.convertLocalDateFromServer(data.dataFineDirezione);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataInizioDirezione = DateUtils.convertLocalDateToServer(copy.dataInizioDirezione);
                    copy.dataFineDirezione = DateUtils.convertLocalDateToServer(copy.dataFineDirezione);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataInizioDirezione = DateUtils.convertLocalDateToServer(copy.dataInizioDirezione);
                    copy.dataFineDirezione = DateUtils.convertLocalDateToServer(copy.dataFineDirezione);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
